<div class="app-snackbar-stack">
  @for (item of stack(); track item.id) {
    <div
      class="app-snackbar-stack__item"
      animate.enter="app-snackbar-stack__item--enter"
      animate.leave="app-snackbar-stack__item--leave"
    >
      <app-snackbar [data]="item.data" (dismissed)="onDismiss(item.id)" />
    </div>
  }
</div>
